import { match } from 'ts-pattern'

import { WorkflowInspectorEntityType } from './types'

export const getAutomationExecutionsParams = (
  entityType: WorkflowInspectorEntityType,
  entityId: string
) =>
  ({
    ...match(entityType)
      .with('QUOTE', () => ({ quoteId: entityId }))
      .with('INVOICE', () => ({ invoiceId: entityId }))
      .exhaustive(),
    limit: 1,
    sortBy: 'startDate',
    sortOrder: 'DESC'
  }) as const
